import 'babel-polyfill';
import 'mutationobserver-shim';

// 토큰 키 통일 마이그레이션 — store 초기화(state.accessToken)보다 먼저 실행되도록 store import 앞에 둔다.
import './token-key-migration';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@custom/shared/store/store.js';
import i18n from '@/i18n';
import * as Sentry from '@sentry/vue';

import '@shared_plugins/start';
import '@shared_plugins/bootstrap-vue';
import '@core_plugins/axios';
import '@core_directives/number-format.directive.js';
import chartPluginJs from '@core_plugins/chart.plugin.js';
import ReportFontPlugin from '@shared_plugins/report/report.font.plugin.js';
import PortalVue from 'portal-vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import createApiInstance from '@core_utils/api/custom.instance.js';
import detectIE from '@shared_mixins/detect_ie';
import commonUtilMixin from '@shared_mixins/common-util-mixin';
import commonLogoutMixin from '@shared_mixins/common-logout-mixin';
import commonErrorHandlingMixin from '@shared_mixins/common-error-handling-mixin';

import SubComponent from '@core_components/client/components/subs/SubComponent';
import BackToTop from '@shared_components/common/BackToTop';
import PdfSimpleViewer from '@shared_components/common/PdfSimpleViewer';
import PdfStandardViewer from '@shared_components/common/PdfStandardViewer';
import '@shared/styles/app.scss';
import '@fontsource-variable/noto-sans-kr';
import '@fontsource-variable/noto-sans-sc';
import '@fontsource-variable/noto-sans-tc';
// 본문 글꼴(DS Pretendard, OFL) — 가변 글꼴을 글자 범위별 조각으로, 화면에 나온 글자의 조각만 받는다. 한자는 위 Noto SC/TC 로
import '@shared/assets/fonts/pretendard/pretendardvariable-dynamic-subset.css';
import {makeProjectAxios} from '@custom/shared/utils/api/projectAxios';
import {tenantKey} from '@custom/shared/utils/tenant';
import {setTenantKey} from '@core_utils/tenant-context';

// hostname 기반 테넌트 판정 결과를 core 계층(axios 인터셉터의 X-Subdomain)에 주입.
// 인터셉터는 요청 시점에 읽으므로 부트스트랩의 이 시점이면 충분히 이르다.
setTenantKey(tenantKey);

Vue.config.productionTip = process.env.VUE_APP_BUILD_ENV == 'staging';
Vue.config.devtools = process.env.VUE_APP_BUILD_ENV !== 'production';

window.EventBus = new Vue();
Vue.prototype.$EventBus = new Vue();

Vue.prototype.$projectsAxios = makeProjectAxios(i18n);

Vue.use(chartPluginJs);
Vue.use(ReportFontPlugin);
Vue.use(PortalVue);

Vue.mixin(detectIE);
Vue.mixin(commonUtilMixin);
Vue.mixin(commonLogoutMixin);
Vue.mixin(commonErrorHandlingMixin);

Vue.prototype.$productAxios = createApiInstance('product', {});
Vue.prototype['$dashboard-error-bus'] = new Vue();

Vue.component('fa', FontAwesomeIcon);
Vue.component('back-to-top', BackToTop);
Vue.component('pdf-simple-viewer', PdfSimpleViewer);
Vue.component('pdf-standard-viewer', PdfStandardViewer);
Vue.component('sub-component', SubComponent);


if (process.env.VUE_APP_BUILD_ENV !== 'production') {
    console.log('process.env => ', process.env);
    console.log(`process.env.NODE_ENV => ${process.env.NODE_ENV}`);
    console.log(`process.env.VUE_APP_BACKENDHOST => ${process.env.VUE_APP_BACKENDHOST}`);
}

// Sentry
Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_BUILD_ENV,
    enabled: process.env.VUE_APP_BUILD_ENV === 'production',
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: [/^https:\/\/hmc.tierzero.kr/],
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        Sentry.BrowserProfilingIntegration({ router }),
        new Sentry.Replay(),
    ],
    tracePropagationTargets: ['localhost', /^https:\/\/backend-custom.dataflare\.net\/api/],
    release: process.env.VUE_APP_SENTRY_SENTRY_RELEASE,
    trackComponents: false, // 컴포넌트별 span 생성 비활성화. true면 BootstrapVue 렌더마다 span이 붙어 트랜잭션당 span이 폭증(~187개)해 Sentry span 과금이 급증한다.

    // Performance Monitoring
    tracesSampleRate: 0.6,

    // Session Replay
    replaysSessionSampleRate: 0, // 일반 세션 녹화 중단(비용 절감). 에러 발생 세션만 아래 onError로 녹화한다.
    replaysOnErrorSampleRate: 0.7 // 에러가 난 세션만 리플레이 녹화
});

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');

Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f);
            }
        };
        window.addEventListener('scroll', f);
    }
});

window.Vue = Vue;
